import { render, staticRenderFns } from "./OperaCouponWindow.vue?vue&type=template&id=28204f12&scoped=true&"
import script from "./OperaCouponWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCouponWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCouponWindow.vue?vue&type=style&index=0&id=28204f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28204f12",
  null
  
)

export default component.exports